import { ValidatorFn } from '@angular/forms';
import { dateValidator } from './functions/date.validator';
import { decimalNumberValidator } from './functions/decimal-number.validator';
import { timeValidator } from './functions/time.validator';
import { phoneNumberValidator } from './functions/phone-number.validator';
import { wholeNumberValidator } from './functions/whole-number';
import { emailValidator } from './functions/email.validator';
import { alphaNumericValidator } from './functions/alpha-numeric.validator';
import { requiredValidator } from './functions/required.validator';
import { matchingFieldValidator } from './functions/matching-field.validator';
import { passwordValidator } from './functions/password.validator';
import { lengthValidator } from './functions/length.validator';
import { checkboxValidator } from './functions/checkbox.validator';

export class CustomValidators {
  public static time: ValidatorFn = timeValidator();
  public static date: ValidatorFn = dateValidator();
  public static decimalNumber: ValidatorFn = decimalNumberValidator();
  public static phoneNumber: ValidatorFn = phoneNumberValidator();
  public static wholeNumber: ValidatorFn = wholeNumberValidator();
  public static alphaNumeric: ValidatorFn = alphaNumericValidator();
  public static email = emailValidator;
  public static password = passwordValidator;
  public static required = requiredValidator;
  public static matchingField = matchingFieldValidator;
  public static lengthValue = lengthValidator;
  public static isChecked = checkboxValidator;
}
